// Single source of truth for the app build stamp (inniva pattern).
// Bump this on every deploy — it forces a new bundle hash, which makes the installed
// home-screen PWA detect the update and show the "new version" reload banner.
// Shown on the More page footer next to the package version.
export const BUILD = '2026-07-31.1';
